import { ChatbotAnswer } from '../../domain/ChatbotSlice/ChatbotAnswer';
import { ChatbotAskAdmin } from '../../domain/ChatbotSlice/ChatbotAskAdmin';
import ApiWrapperAuthenticated from '../Common/ApiWrapperAuthenticated';

export class ChatbotAdminRepository extends ApiWrapperAuthenticated<ChatbotAnswer> {
    constructor() {
        super('chatbot/admin/');
    }

    async ask(message: ChatbotAskAdmin): Promise<ChatbotAnswer | null> {
        return await this.postAuthenticatedCustom({url: '', data: message});
    }
}
